<template>
  <v-container fluid :class="$style.container">
    <v-row :class="$style.wrapper">
      <v-col sm="12" cols="12">
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped module>
.container {
  flex: none !important;
  padding: 0 2rem 0 2rem;
  background-color: #fff;
  left: $navbarWidth!important;
}
</style>
